import colors from "../colors";

export default {
    ...colors,
    primary: colors["cs-purple"],
    secondary: colors["cs-teal"],
    accent: colors["cs-teal"],
};
